var exports = {
  "k": "x620889e6--1cfaff--container",
  "s": "x620889e6--1cfaff--edit-button",
};

module.exports = exports;
